// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__321Xo","title":"styles_title__2cwMt"};